<span
  matRipple
  class="mat-button-ripple nav-link-ripple"
  [class.mat-button-ripple-round]="isRoundButton || isIconButton"
  [matRippleDisabled]="_isRippleDisabled()"
  [matRippleCentered]="isIconButton"
  [matRippleTrigger]="_getHostElement()"
></span>
<ng-content select="emperor-icon:not(.icon-suffix)"></ng-content>
<ng-content></ng-content>

<div class="emperor-ui-chip-container">
  <ng-content select="emperor-chip"></ng-content>
</div>

<ng-content select=".icon-suffix"></ng-content>
